import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import * as TransferHttp from '../../../../services/api/https/deliveries/delivery-transfer.http'
import { getPeriodoFromLastXDays } from '../../../../services/util/date.service'

const { pInicial, pFinal } = getPeriodoFromLastXDays(60)

const INITIAL_STATE = {
  entregas: [],
  entregasOriginais: [],
  isContentLoading: false,
  empresaSelecionada: '',
  tpSelecionado: '',
  ciclos: [],
  cicloSelecionado: '',
  empresas: [],
  tps: [],
  errorMessage: null,
  successMessage: null,
  isBtnLoading: false,
  selecionarTodos: false,
  pInicial,
  pFinal,
  qteIdentifiers: 0,
  qteSkus: 0,
  pesoTotal: 0,
  modalDisponivel: { show: false, data: null },
}

export default function useTransferenciaAssocEntrega(transferencia, selectedTp) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const calcularValoresCards = entregas => {
    const entregasSelecionadas = entregas.filter(e => e.selected === 1)
    const qteIdentifiers = entregasSelecionadas.length
    const qteSkus = entregasSelecionadas.reduce(
      (total, entrega) => total + (entrega.qte_sku || 0),
      0,
    )
    const pesoTotal = entregasSelecionadas.reduce(
      (total, entrega) => total + (entrega.weight || 0),
      0,
    )
    return { qteIdentifiers, qteSkus, pesoTotal }
  }

  const localDispatch = useMemo(() => {
    return {
      resetMessages() {
        setState(prevState => ({ ...prevState, errorMessage: null, successMessage: null }))
      },
      openModalDisponivel(entrega) {
        setState(prevState => ({
          ...prevState,
          modalDisponivel: { show: true, data: entrega },
        }))
      },
      closeModalDisponivel() {
        setState(prevState => ({
          ...prevState,
          modalDisponivel: { show: false, data: null },
        }))
      },
      async saveAvailableToTransfer(delivery_id, available_to_transfer, transfer_not_available_reason) {
        try {
          setState(prevState => ({ ...prevState, isBtnLoading: true }))
          await TransferHttp.updateAvailableToTransfer(delivery_id, available_to_transfer, transfer_not_available_reason)
          setState(prevState => ({
            ...prevState,
            isBtnLoading: false,
            successMessage: 'Disponibilidade para transferência atualizada com sucesso',
            modalDisponivel: { show: false, data: null },
            entregas: prevState.entregas.map(e =>
              e.delivery_id === delivery_id
                ? { ...e, available_to_transfer, transfer_not_available_reason: available_to_transfer ? null : transfer_not_available_reason }
                : e
            ),
            entregasOriginais: prevState.entregasOriginais.map(e =>
              e.delivery_id === delivery_id
                ? { ...e, available_to_transfer, transfer_not_available_reason: available_to_transfer ? null : transfer_not_available_reason }
                : e
            ),
          }))
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            isBtnLoading: false,
            errorMessage: errorHandler(error),
          }))
        }
      },
      calcularValoresCards,
      selecionarTodos(value) {
        setState(prevState => {
          const entregasAtualizadas = prevState.entregas.map(e => ({
            ...e,
            selected: value ? 1 : 0,
          }))
          const { qteIdentifiers, qteSkus, pesoTotal } = calcularValoresCards(entregasAtualizadas)
          return { ...prevState, entregas: entregasAtualizadas, qteIdentifiers, qteSkus, pesoTotal }
        })
      },
      checkRow(entrega) {
        setState(prevState => {
          const entregasAtualizadas = prevState.entregas.map(e =>
            e.delivery_step_id === entrega.delivery_step_id
              ? { ...e, selected: e.selected === 1 ? 0 : 1 }
              : e,
          )
          const { qteIdentifiers, qteSkus, pesoTotal } = calcularValoresCards(entregasAtualizadas)
          return { ...prevState, entregas: entregasAtualizadas, qteIdentifiers, qteSkus, pesoTotal }
        })
      },
      async salvar(entregas, pInicial, pFinal) {
        try {
          setState(prevState => ({ ...prevState, isBtnLoading: true }))

          const associacoes = entregas.map(e => ({
            delivery_step_id: e.delivery_step_id,
            selected: e.selected,
          }))

          const respEntregas = await TransferHttp.saveAssocDeliveryStepWithTransfer(
            selectedTp,
            transferencia.transfer_id,
            associacoes,
            pInicial,
            pFinal,
          )

          setState(prevState => ({
            ...prevState,
            successMessage: 'Operação realizada com sucesso',
            isBtnLoading: false,
            entregas: respEntregas,
            entregasOriginais: respEntregas,
            empresaSelecionada: '',
            tpSelecionado: '',
            selecionarTodos: false,
            qteIdentifiers: 0,
            qteSkus: 0,
            pesoTotal: 0,
          }))
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            errorMessage: errorHandler(error),
            isContentLoading: false,
            isBtnLoading: false,
          }))
        }
      },
      limpar() {
        setState(prevState => {
          const { qteIdentifiers, qteSkus, pesoTotal } = calcularValoresCards(
            prevState.entregasOriginais,
          )
          return {
            ...prevState,
            empresaSelecionada: '',
            tpSelecionado: '',
            cicloSelecionado: '',
            selecionarTodos: false,
            entregas: prevState.entregasOriginais,
            qteIdentifiers,
            qteSkus,
            pesoTotal,
          }
        })
      },
      async fetchDeliveriesToBeTransferred(pInicial, pFinal) {
        try {
          setState(prevState => ({ ...prevState, isContentLoading: true, pInicial, pFinal }))
          let entregas = await TransferHttp.getDeliveriesToBeTransfered(
            selectedTp,
            transferencia.transfer_id,
            pInicial,
            pFinal,
          )
          entregas =
            transferencia.status === 'Transferida'
              ? entregas.filter(e => e.selected === 1)
              : entregas
          const { qteIdentifiers, qteSkus, pesoTotal } = calcularValoresCards(entregas)
          setState(prevState => ({
            ...prevState,
            entregas,
            entregasOriginais: entregas,
            isContentLoading: false,
            empresas: getEmpresas(entregas),
            tps: getTps(entregas),
            ciclos: getCiclos(entregas),
            qteIdentifiers,
            qteSkus,
            pesoTotal,
          }))
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            isContentLoading: false,
            errorMessage: errorHandler(error),
          }))
        }
      },

      onFormDataChange(fieldName, value) {
        switch (fieldName) {
          case 'selecionarTodos':
            setState(prevState => {
              const entregasAtualizadas = prevState.entregas.map(e => ({
                ...e,
                selected: value ? 1 : 0,
              }))
              const { qteIdentifiers, qteSkus, pesoTotal } =
                calcularValoresCards(entregasAtualizadas)
              return {
                ...prevState,
                selecionarTodos: value,
                entregas: entregasAtualizadas,
                qteIdentifiers,
                qteSkus,
                pesoTotal,
              }
            })
            break
          case 'empresaSelecionada':
            setState(prevState => {
              const entregas = filtrarEntregas(
                value, // selEmpresa
                prevState.tpSelecionado, // selTp
                prevState.cicloSelecionado, // selCiclo
                prevState.entregasOriginais, // originais
              )
              const { qteIdentifiers, qteSkus, pesoTotal } = calcularValoresCards(entregas)
              return {
                ...prevState,
                entregas,
                empresaSelecionada: value,
                qteIdentifiers,
                qteSkus,
                pesoTotal,
              }
            })
            break
          case 'tpSelecionado':
            setState(prevState => {
              const entregas = filtrarEntregas(
                prevState.empresaSelecionada, // selEmpresa
                value, // selTp
                prevState.cicloSelecionado, // selCiclo
                prevState.entregasOriginais, // originais
              )
              const { qteIdentifiers, qteSkus, pesoTotal } = calcularValoresCards(entregas)
              return {
                ...prevState,
                entregas,
                tpSelecionado: value,
                qteIdentifiers,
                qteSkus,
                pesoTotal,
              }
            })
            break
          case 'cicloSelecionado':
            setState(prevState => {
              const entregas = filtrarEntregas(
                prevState.empresaSelecionada,
                prevState.tpSelecionado,
                value,
                prevState.entregasOriginais,
              )
              const { qteIdentifiers, qteSkus, pesoTotal } = calcularValoresCards(entregas)
              return {
                ...prevState,
                cicloSelecionado: value,
                entregas,
                qteIdentifiers,
                qteSkus,
                pesoTotal,
              }
            })
            break
          default:
            break
        }
      },
    }
  }, [])

  return { state, localDispatch }
}

function filtrarEntregas(selEmpresa, selTp, selCiclo, originais = []) {
  return originais
    .filter(e => !selEmpresa || e.company_id === selEmpresa.id)
    .filter(e => !selTp || e.tp_id === selTp.id)
    .filter(e => !selCiclo || e.cycle_id === selCiclo.id)
}

function getEmpresas(entregas) {
  const empresasIds = new Set(entregas.map(e => e.company_id))
  const empresas = []
  empresasIds.forEach(empresa_id => {
    const entrega = entregas.find(e => e.company_id === empresa_id)
    entrega && empresas.push({ id: entrega.company_id, name: entrega.company_name })
  })
  return empresas
}
function getTps(entregas) {
  const tpsIds = new Set(entregas.map(e => e.tp_id))
  const tps = []
  tpsIds.forEach(tp_id => {
    const entrega = entregas.find(e => e.tp_id === tp_id)
    entrega && tps.push({ id: entrega.tp_id, name: entrega.tp_name })
  })
  return tps
}
function getCiclos(entregas) {
  const uniqueIds = Array.from(new Set(entregas.map(e => e.cycle_id)))
  return uniqueIds.map(id => {
    const e = entregas.find(x => x.cycle_id === id)
    return { id, name: `${id} - ${e.cycle_name}` }
  })
}
